//  등록, 수정 페이지 Type
const ACTION_TYPE = {
  CREATE: 'create',
  UPDATE: 'update'
};

const DISABLE_TYPE = {
  create: false,
  update: true
};

// BestMix 전송
const BEST_MIX_STATUS = {
  NONE: '',
  UPLOAD: '▲',
  BESTMIX_TRANS: '●'
};

// CCP 관리여부 Select Box
const CCP_YN_SELECT = [
  { key: 'Y', value: 'Y' },
  { key: 'N', value: 'N' }
];

// 코드 검색 구분
const CODE_SEARCH_TYPE = {
  PRDT: 0,
  MIX: 1
};

// 결재권한
const HACCP_AUTH_TYPE = {
  ADMIN: 'ADMIN',
  FIRST: 'FIRST',
  SECOND: 'SECOND',
  DRAFT: 'DRAFT'
};

const HACCP_AUTH_TYPE_SELECT = {
  ADMIN: '관리자',
  DRAFT: '기안자',
  FIRST: '1차 결재자',
  SECOND: '2차 결재자'
};

const MONTH_SELECT = [
  { key: 1, value: '1월' },
  { key: 2, value: '2월' },
  { key: 3, value: '3월' },
  { key: 4, value: '4월' },
  { key: 5, value: '5월' },
  { key: 6, value: '6월' },
  { key: 7, value: '7월' },
  { key: 8, value: '8월' },
  { key: 9, value: '9월' },
  { key: 10, value: '10월' },
  { key: 11, value: '11월' },
  { key: 12, value: '12월' }
];

const MONTH_STATUS = {
  1: '1월',
  2: '2월',
  3: '3월',
  4: '4월',
  5: '5월',
  6: '6월',
  7: '7월',
  8: '8월',
  9: '9월',
  10: '10월',
  11: '11월',
  12: '12월'
};

const QUATER_SELECT = [
  { key: 1, value: '1분기' },
  { key: 2, value: '2분기' },
  { key: 3, value: '3분기' },
  { key: 4, value: '4분기' }
];

const HALF_YEAR_SELECT = [
  { key: 1, value: '상반기' },
  { key: 2, value: '하반기' }
];

// 모선정보 상태 Select Box
const MOTHER_SHIP_STATUS_SELECT = [
  { key: 1, value: '사용중' },
  { key: 2, value: '사용완료' }
];

const MOTHER_SHIP_STATUS = {
  1: '사용중',
  2: '사용완료'
};

// 배합비
const RATIO_STATUS = {
  REGULAR: 'REGULAR',
  MODIFY: 'MODIFY'
};

// 원료 가격 구분
const RAW_MATERIAL_PRICE_TYPE = {
  MARKET: 0,
  STOCK: 1
};

// 반송여부 Select Box
const RETURN_YN_SELECT = [
  { key: 'Y', value: 'Y' },
  { key: 'N', value: 'N' }
];

const RETURN_YN = {
  Y: 'Y',
  N: 'N'
};

// SAP 전송
const SAP_STATUS = {
  NONE: '',
  SAP_DOWN: '▲',
  SAP_TRANS: '●'
};

// 사용여부 Select Box
const USE_YN_SELECT = [
  { key: 'Y', value: '사용' },
  { key: 'N', value: '미사용' }
];

const USE_YN = {
  1: '사용',
  2: '미사용'
};

// 사용여부 Select Box
const USE_YN_SELECT_EN = [
  { key: 'Y', value: 'Y' },
  { key: 'N', value: 'N' }
];

// 모니터링 - 제품주기 검사종류
const INSPECTION_TYPE = {
  1: '등록성분',
  2: 'BSE',
  3: '안전성',
  4: '아미노산',
  5: '배합정밀도',
  6: '잔류농약',
  7: '동물용의약품'
};

// 조치내역 결재 상태 Select Box
const APPROVAL_STATUS_SELECT = [
  { key: 1, value: '미등록' },
  { key: 2, value: '기안중' },
  { key: 3, value: '결재중' },
  { key: 4, value: '수정요청중' },
  { key: 5, value: '결재' }
];

// 조치내역 결재 상태
const APPROVAL_STATUS = {
  1: '미등록',
  2: '기안중',
  3: '결재중',
  4: '수정요청중',
  5: '결재'
};

// 조치내역 결재상태에 따른 결재버튼 상태
const APPROVAL_BUTTON_TEXT = {
  1: '임시저장',
  2: '결재요청',
  3: '수정요청',
  4: '수정요청 승낙',
  5: '수정요청 거절',
  6: '결재',
  7: '반려'
};

// 주기 Select Box
const CYCLE_SELECT = [
  // { key: 'mt', value: '월' },
  { key: 'qt', value: '분기' },
  { key: 'hf', value: '반기' },
  { key: 'oy', value: '연' }
];

// 검사결과 Select Box
const RESULT_TYPE_SELECT = [
  { key: 1, value: '시료분석 결과(하림)' },
  { key: 2, value: '성분분석 결과(사협)' },
  { key: 3, value: '동물성단백질 결과(하림)' },
  { key: 4, value: '위생검사 결과(하림)' }
];

// 검사결과 이상여부
const EXCD_YN = {
  Y: '기준치 이탈',
  N: '기준치 이내'
};

export {
  ACTION_TYPE,
  DISABLE_TYPE,
  BEST_MIX_STATUS,
  CCP_YN_SELECT,
  CODE_SEARCH_TYPE,
  HACCP_AUTH_TYPE,
  HACCP_AUTH_TYPE_SELECT,
  MONTH_SELECT,
  MONTH_STATUS,
  MOTHER_SHIP_STATUS_SELECT,
  MOTHER_SHIP_STATUS,
  QUATER_SELECT,
  HALF_YEAR_SELECT,
  RATIO_STATUS,
  RAW_MATERIAL_PRICE_TYPE,
  RETURN_YN_SELECT,
  RETURN_YN,
  SAP_STATUS,
  USE_YN_SELECT,
  USE_YN,
  USE_YN_SELECT_EN,
  INSPECTION_TYPE,
  APPROVAL_STATUS_SELECT,
  APPROVAL_STATUS,
  APPROVAL_BUTTON_TEXT,
  CYCLE_SELECT,
  RESULT_TYPE_SELECT,
  EXCD_YN
};
